import { render, staticRenderFns } from "./ArticleUpdat.vue?vue&type=template&id=3c3bc070&"
import script from "./ArticleUpdat.vue?vue&type=script&lang=js&"
export * from "./ArticleUpdat.vue?vue&type=script&lang=js&"
import style0 from "./ArticleUpdat.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports